import React from "react";
import CustomButton from "../../../components/CustomButton";
import { Link } from "react-router-dom";

const FileClaim = () => {
  return (
    <div className="file-claim">
      <div>
        <h1 className="header text-center">
          Don’t let flight disruptions go uncompensated
        </h1>
        <p className="sub-header">
          Start your claim now and let us handle the rest.
        </p>
        <Link to={"/start-your-claim"}>
          <CustomButton btnText={"FILE YOUR CLAIM TODAY"} />
        </Link>
      </div>
    </div>
  );
};

export default FileClaim;
